// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FolderMoveSvg from '@rsuite/icon-font/lib/file/FolderMove';
var FolderMove = createSvgIcon({
  as: FolderMoveSvg,
  ariaLabel: 'folder move',
  category: 'file',
  displayName: 'FolderMove'
});
export default FolderMove;